import styles from "./singleTour.module.css";
import ax1 from "assets/image/abshar.jpg";
import ax2 from "assets/image/abshar2.jpg";
import ax3 from "assets/image/abshar3.jpg";
import jomeSobLogo from "assets/image/travel.png";
import Contact from "./Contact";
import "./style.css";
import {
  FaShoppingCart,
  FaCampground,
  FaCcVisa,
  FaChevronDown,
} from "react-icons/fa";
import "react-multi-date-picker/styles/colors/green.css";
import { Calendar, DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import buyImg from "assets/image/listTour/001.jpg";
import pricelogo2 from "assets/image/listTour/002.png";
import pricelogo3 from "assets/image/listTour/003.png";
import pricelogo4 from "assets/image/listTour/004.png";
import pricelogo5 from "assets/image/listTour/005.png";
import pricelogo from "assets/image/listTour/009.png";
import pricelogo6 from "assets/image/listTour/006.png";
import pricelogo7 from "assets/image/listTour/007.png";
import pricelogo8 from "assets/image/listTour/008.png";
import pricelogo9 from "assets/image/listTour/010.png";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";
import axios from "axios";
import TableIndex from "./TableIndex";
import FinalSection from "./FinalSection";
import Loader from "utilities/Loader";
import AuthenticationContext from "Authentication/AuthenticationContext";
import Helmet from "react-helmet";
import { getTourInfoForReserve } from "services/reserveTour";

function SingleTour() {
  const params = useParams();

  const { userInfo, isLogged } = useContext(AuthenticationContext);

  const [tourDetail, setTourDetail] = useState([]);
  const [allAccessories, setAllAccessories] = useState([]);
  const [tourAttrac, setTourAttrac] = useState([]);
  const [loader, setLoader] = useState(true);
  const [finalSectionData, setFinalSectionData] = useState({
    tourId: 0,
    mainStatus: "",
    capacity: "",
    seats: "",
    busType: "",
    prices: "",
    pastPassangers: "",
    wallet: "",
  });

  const changeLoader = debounce((state) => {
    setLoader(state);
  }, 1000);

  const date = (TimeStamp) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString(
      "fa-IR",
      options
    );
    date.replace(/([۰-۹])/g, (token) =>
      String.fromCharCode(token.charCodeAt(0) - 1728)
    );
    return date;
  };

  useEffect(() => {
    async function loadPage() {
      let id = params.tourId;
      changeLoader(true, 1);
      if (isLogged) {
        let res = await getTourInfoForReserve(id, userInfo.id);
        setFinalSectionData({
          tourId: id,
          mainStatus: 4,
          // mainStatus: res.info.main_status,
          capacity: res.info.capacity,
          seats: res.seats,
          busType: res.busType,
          prices: res.prices,
          pastPassangers: res.pastPassangers,
          wallet: res.wallet,
        });
      }
      changeLoader(false, 1);
    }

    loadPage().catch((error) => {
      console.log(error);
    });
  }, [isLogged]);

  useEffect(() => {
    async function loadPage() {
      let FD = new FormData();
      let tourId = parseInt(params.tourId);

      FD.append("tour_id", tourId);

      let res = await axios
        .post("http://mvc.dade24.ir/api/fulltour", FD)
        .then((res) => res.data.data);
      setTourDetail(res[0]);

      FD = new FormData();
      FD.append("conditions", "tour_id/=/" + tourId);
      FD.append("tbl_name", "attractions");
      res = await axios
        .post("http://mvc.dade24.ir/api/Find_tour_Attraction_links", FD)
        .then((res) => res.data);
      setTourAttrac(res);
      changeLoader(false, 2);
    }

    loadPage();
  }, []);

  let h = +tourDetail.complate_reserved + +tourDetail.frozen_reserved;
  console.log("h", h);
  const fun = () => {
    let x = tourDetail.essentials_accessories;
    if (x === undefined) {
      return console.log("undei");
    } else {
      let i = x.split("+");
      return i.toString();
    }
  };
  let i = fun();
  const funcDaily = () => {
    let x = tourDetail.tour_daily_schedule;
    let i = 0;
    let newArray = [];
    if (x != undefined) {
      for (let index = 0; index <= 9; index++) {
        i = tourDetail.tour_daily_schedule.filter((i) => i.daynum == index);
        if (i.length >= 1) {
          newArray.push(i);
        }
      }
    }
    return newArray;
  };
  let dailyUpdate = funcDaily();
  const essen = () => {
    let x = tourDetail.essentials;
    if (x != undefined) {
      return x[0].val;
    } else {
      return console.log("err");
    }
  };
  const dateChek = () => {
    const d = new Date();
    const datenow = new Date(d).getTime() / 1000;
    const datetakhfif = tourDetail.takhfiftm;
    const pric = tourDetail.mainprice;
    const takhtm = tourDetail.takhfif;
    if (datenow < datetakhfif) {
      return addCommas(pric - takhtm);
    } else {
      return addCommas(pric);
    }
  };
  return (
    <>
      {loader ? <Loader /> : null}
      <Helmet>
        <title>{tourDetail.title + " | "} جمه صب</title>
      </Helmet>
      <div className="container mt-4">
        <div className={styles.header}>
          <p
            className="my-0 mx-2"
            style={{ fontWeight: "bold", fontSize: "21px" }}
          >
            {tourDetail.title}
          </p>
          <p className={styles.greenTextHeader}>{tourDetail.eghaamat}</p>
          <p className={styles.greenTextHeader}>-</p>
          <p className={styles.greenTextHeader}>
            {tourDetail.vasilenaghlieasli}
          </p>
          <div className={styles.tarikhHeader}>{tourDetail.modaattour}</div>
          <div
            className="text-danger"
            style={{ fontWeight: "bold", fontSize: "17px" }}
          >
            پایان تخفیف تا <bdi>{date(tourDetail.takhfiftm)}</bdi>
          </div>
        </div>
        <div className={`d-flex  justify-content-between ${styles.boxSlide}`}>
          <div className={styles.slid}>
            <div
              id="carouselExampleControls"
              class="carousel slide"
              data-bs-ride="carousel"
              style={{ borderRadius: "20px !important" }}
            >
              <div class={`carousel-inner ${styles.heiMain}`}>
                <div
                  className={"carousel-item active carousell"}
                  id="carouselExampleIndicators-0"
                >
                  <img
                    src={
                      tourDetail.cover_pic
                        ? "http://mvc.dade24.ir/" + tourDetail.cover_pic
                        : jomeSobLogo
                    }
                    className="d-block w-100"
                    alt="..."
                    style={{ maxHeight: "500px", objectFit: "fill" }}
                  />
                </div>
                {tourDetail.attraction?.map((value, index) => {
                  if (value.mainpic == "") return null;
                  return (
                    <div
                      className={`carousel-item carousell`}
                      id={`carouselExampleIndicators-${index + 1}`}
                    >
                      <img
                        src={"http://mvc.dade24.ir/" + value.mainpic}
                        className="d-block w-100 tour-image"
                        alt="..."
                        style={{ maxHeight: "500px", objectFit: "fill" }}
                      />
                    </div>
                  );
                })}
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="next"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className={styles.buy}>
            <div className={styles.priceTour} style={{ marginBottom: "-10px" }}>
              {" "}
              قیمت تور : <bdi> {dateChek()}</bdi> تومان
            </div>
            <div className={styles.priceTour}>
              {" "}
              ظرفیت باقی مانده :
              {tourDetail.public_capacity - h <= 0 ? (
                "ظرفیت تکمیل"
              ) : (
                <>
                  <bdi>{tourDetail.public_capacity - h}</bdi> نفر
                </>
              )}
            </div>
            <div className={styles.onlineTour}>
              {" "}
              <bdi className="text-danger">آنلاین</bdi>{" "}
              <bdi>خرید یا رزرو کنید!</bdi>{" "}
            </div>
            <img src={buyImg} className={styles.buyimg} />
          </div>
        </div>
        <div className={styles.jazebe}>
          <p className={styles.jazebeHead}>جاذبه ها</p>

          <p
            className="d-flex"
            style={{
              marginRight: "20px",
              lineHeight: "30px",
              marginBottom: "2px",
            }}
          >
            {tourAttrac.map((contact) => {
              return <Contact contact={contact} />;
            })}
          </p>
        </div>
        <div className={`d-flex  justify-content-between ${styles.boxSection}`}>
          <div className={styles.tableContainer}>
            <table className={`table mb-0 ${styles.sotun}`}>
              <thead>
                <tr>
                  <th colspan="2">
                    {" "}
                    <p className={styles.jazebeHead}> خلاصه سفر</p>{" "}
                  </th>
                </tr>
              </thead>
              <tbody className={styles.radif}>
                <tr>
                  <th width="175" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo2} className={styles.logo} />
                      <p className={styles.textp}> اقامت</p>
                    </div>
                  </th>
                  <td>{tourDetail.eghaamat}</td>
                </tr>
                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo9} className={styles.logo} />
                      <p className={styles.textp}> اعداد وعده غذایی</p>
                    </div>
                  </th>
                  <td>{tourDetail.tedadvadeghazaee}</td>
                </tr>
                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo3} className={styles.logo} />
                      <p className={styles.textp}> محل حرکت</p>
                    </div>
                  </th>
                  <td>{tourDetail.mahalharkat}</td>
                </tr>
                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo4} className={styles.logo} />
                      <p className={styles.textp}> مدت</p>
                    </div>
                  </th>
                  <td>{tourDetail.modaattour}</td>
                </tr>
                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo5} className={styles.logo} />
                      <p className={styles.textp}> زمان حرکت</p>
                    </div>
                  </th>
                  <td>{tourDetail.zamaneharkat}</td>
                </tr>
                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo6} className={styles.logo} />
                      <p className={styles.textp}> وسیله نقلیه اصلی</p>
                    </div>
                  </th>
                  <td>{tourDetail.vasilenaghlieasli}</td>
                </tr>
                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo7} className={styles.logo} />
                      <p className={styles.textp}> وسیله نقلیه کمکی</p>
                    </div>
                  </th>
                  <td>{tourDetail.vasilenaghliekomaki}</td>
                </tr>

                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo8} className={styles.logo} />
                      <p className={styles.textp}> استان مورد بازدید</p>
                    </div>
                  </th>
                  <td>{tourDetail.ostanmoredbazdid}</td>
                </tr>
                <tr>
                  <th className="rowHead" scope="row">
                    <div className="d-flex">
                      <img src={pricelogo} className={styles.logo} />
                      <p className={styles.textp}>قیمت</p>
                    </div>
                  </th>
                  <td>
                    {dateChek()}
                    <button
                      className="btn btn-success mx-2"
                      style={{ padding: "1px 5px", borderRadius: "9px" }}
                    >
                      خرید آنلاین
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            className={`d-flex flex-column justify-content-between ${styles.mapBox}`}
          >
            <div className="w-100">
              <div className="row  text-dark w-100 ">
                <Calendar
                  className="green  start-end-calendar taghvim"
                  value={[tourDetail.stm * 1000, tourDetail.ftm * 1000]}
                  range
                  readOnly
                  calendar={persian}
                  locale={persian_fa}
                />
              </div>
            </div>
            <div>
              <iframe
                src={tourDetail.naghshe}
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                className="naghshe"
              >
                <a
                  href="http://www.siteway.de/maps-generator/"
                  title="Google Maps für Ihre Homepage"
                >
                  (c) Homepage Google Maps Generator
                </a>
              </iframe>
            </div>
            <p className="m-0 mt-2">
              نقشه را بزرگ کنید تا اطلاعات بیشتری از تور ببینید
            </p>
          </div>
        </div>
        <div
          className={`d-flex mt-5  justify-content-between flex-wrap ${styles.boxSection}`}
        >
          {dailyUpdate.map((tableArry, index) => {
            return <TableIndex index={index} tableArry={tableArry} />;
          })}
        </div>
        <div className={styles.jazebe5}>
          <p className={styles.jazebeHead1}>لوازم ضروری </p>
          <p className={styles.pJazebe}>{i} </p>
        </div>
        <div className={styles.jazebe1}>
          <p className={styles.jazebeHead1}> لوازم پیشنهادی</p>
          <p className={styles.pJazebe}>{essen()}</p>
        </div>
        <FinalSection finalSectionData={finalSectionData} />
      </div>
    </>
  );
}

export default SingleTour;
